var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1-1/2 rounded-full  text-white text-xs scale-85 leading-4",class:[("bg-" + _vm.color + "-500")]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }